import { SourceTypeEnum } from '@/bundles/App/enums';

export * from './getIsSortChanged';

// Maps a source/source-type to its LIST-route name for "back to list" / "go to
// filtered set" navigation. Single source of truth for routing — the previous
// per-component escape hatches (sign, eblast, marketing*, custom-rows, …) are
// folded in here. Only sources that actually have a list route are listed.
export const sourceListRouteName: Record<string, string> = {
  [SourceTypeEnum.company]: 'companies',
  [SourceTypeEnum.contact]: 'contacts',
  [SourceTypeEnum.occupier]: 'occupiers',
  requirement: 'requirements',
  [SourceTypeEnum.property]: 'properties',
  [SourceTypeEnum.availability]: 'availabilities',
  [SourceTypeEnum.comparable]: 'comparables',
  project: 'projects',
  [SourceTypeEnum.pipeline]: 'pipelines',
  [SourceTypeEnum.pipelinesDashboard]: 'pipelines',
  [SourceTypeEnum.dealsDashboard]: 'deals',
  [SourceTypeEnum.deal]: 'deals',
  [SourceTypeEnum.availabilitiesDashboard]: 'availabilities',
  [SourceTypeEnum.comparablesDashboard]: 'comparables',
  request: 'requests',
  member: 'members',
  team: 'teams',
  filter: 'filters',
  sign: 'sign-list',
  pressrelease: 'PressReleases',
  eblast: 'marketing-eblasts',
  marketingCampaign: 'marketing-campaigns',
  marketingTemplates: 'marketing-templates',
  customRows: 'custom-rows',
};

export const appPanelName: Record<string, string> = {
  [SourceTypeEnum.company]: 'Companies',
  [SourceTypeEnum.contact]: 'Contacts',
  [SourceTypeEnum.occupier]: 'Occupiers',
  requirement: 'Requirements',
  [SourceTypeEnum.property]: 'Properties',
  [SourceTypeEnum.availability]: 'Availabilities',
  [SourceTypeEnum.comparable]: 'Comparables',
  project: 'Presentations',
  [SourceTypeEnum.pipeline]: 'Pipelines',
  [SourceTypeEnum.pipelinesDashboard]: 'Pipeline Dashboard',
  [SourceTypeEnum.dealsDashboard]: 'Deals',
  [SourceTypeEnum.deal]: 'Deals',
  [SourceTypeEnum.availabilitiesDashboard]: 'Availabilities',
  [SourceTypeEnum.comparablesDashboard]: 'Comparables',
  savedSet: 'Saved Sets',
  request: 'Requests',
  member: 'Members',
  team: 'Teams',
  filter: 'Filters',
  eblast: 'Eblasts',
  pressrelease: 'Press Releases',
  pressreleases: 'Press Releases',
  dashboard: 'Dashboard',
  map: 'Spatial GIS',
  marketing: 'Marketing Dashboard',
  'eblast-list': 'Eblasts',
  marketingTemplates: 'Marketing Templates',
  marketingCampaign: 'Campaigns',
  customRows: 'Custom Rows',
  signList: 'Signs',
  sign: 'Signs',
  document: 'Documents',
};
